module.exports = new __parcel__URL__("chrome-first-paint.c9a2786b.jpeg").toString();